import { createSlice } from "@reduxjs/toolkit";

export const initFilterValue = {
  fromPage: "",
};

const initialState = {
  filterValue: initFilterValue,
};

export const scheduleSlice = createSlice({
  name: "filterValue",
  initialState,
  reducers: {
    setFilterValue: (state, action) => {
      state.filterValue = {
        ...state.filterValue,
        ...action.payload,
      };
    },
  },
});

export const { setFilterValue } = scheduleSlice.actions;
export default scheduleSlice.reducer;
